export interface SurveyConfig {
  /** Same-origin survey API base (empty string = relative). */
  apiBaseUrl: string;
  stage: string;
}

let cached: SurveyConfig | null = null;

export async function loadSurveyConfig(): Promise<SurveyConfig> {
  if (cached) return cached;
  try {
    const res = await fetch("/config.json", { cache: "no-store" });
    if (res.ok) {
      const json = (await res.json()) as Partial<SurveyConfig> & {
        surveyApiBaseUrl?: string;
      };
      cached = {
        apiBaseUrl: json.surveyApiBaseUrl ?? json.apiBaseUrl ?? "",
        stage: json.stage ?? "prod",
      };
      return cached;
    }
  } catch {
    /* local */
  }
  cached = {
    apiBaseUrl: import.meta.env.VITE_SURVEY_API_BASE_URL ?? "",
    stage: import.meta.env.VITE_STAGE ?? "dev",
  };
  return cached;
}
